import React from 'react';
import IconButton from '@mui/material/IconButton';

import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { useAppSelector } from 'src/app/hooks';
import { Layout } from 'src/styles';
import {
  getProductionTimeRangeLabel,
  ProductionTimeRange,
} from 'src/constants/ProductionTimeRange';
import Box from '@mui/material/Box';

export default function CardTotalsMenu({
  timeRange,
  setTimeRange,
}: {
  timeRange: ProductionTimeRange;
  setTimeRange: (x: ProductionTimeRange) => void;
}) {
  const { usuaria } = useAppSelector((state) => state.page);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClickUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!usuaria) {
    return null;
  }

  return (
    <Box>
      <Tooltip title="Mais opções">
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          size="small"
          aria-controls={anchorEl ? 'perfil-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={anchorEl ? 'true' : undefined}
          onClick={handleClickUserMenu}
          sx={{ ml: 2 }}>
          <MoreVertIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="perfil-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: Layout.IconMenu,
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
        {Object.values(ProductionTimeRange).map((menuItem) => (
          <MenuItem
            key={`menu_${menuItem}`}
            color="inherit"
            disabled={timeRange === menuItem}
            onClick={() => {
              handleClose();
              setTimeRange(menuItem);
            }}>
            {getProductionTimeRangeLabel(menuItem)}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
